import { render } from "./SearchBar.vue?vue&type=template&id=270964a6"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/HistoricalData/DiagnosisReport/components/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270964a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270964a6', __exports__)) {
    api.reload('270964a6', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=270964a6", () => {
    api.rerender('270964a6', render)
  })

}


export default __exports__